import React from 'react';

export default function Text({ text }) {
	return <div dangerouslySetInnerHTML={{ __html: text }}></div>;
}
